import { isWithinInterval, parseISO } from 'date-fns'
import { holidays } from '~/data/constants'

export const getMatchingHolidays = (startDate, endDate) => {
  if (!startDate || !endDate) return []
  if (startDate.length !== 10 || endDate.length !== 10) return []
  if (startDate >= endDate) return []
  if (startDate === '0000-00-00' || endDate === '0000-00-00') return []

  const tourStart = parseISO(startDate)
  const tourEnd = parseISO(endDate)
  const matching = []

  for (const year in holidays) {
    const yearData = holidays[year]
    for (const category in yearData) {
      for (const holiday of yearData[category]) {
        const holidayStart = parseISO(holiday.baslangic)
        if (isWithinInterval(holidayStart, { start: tourStart, end: tourEnd })) {
          matching.push({ ...holiday, kategori: category, yil: year })
        }
      }
    }
  }

  return matching
}
